import React, { useRef, useState } from 'react';

const ProfilePicture = ({ imageSrc, isLoggedInUser, onUpload }) => {
    const inputRef = useRef(null);
    const [uploadError, setUploadError] = useState('');
    const [isUploading, setIsUploading] = useState(false);

    const handleFileChange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        setUploadError('');
        setIsUploading(true);
        try {
            await onUpload(file);
        } catch (error) {
            setUploadError(
                error.response?.data?.detail || 'Unable to upload photo.'
            );
        } finally {
            setIsUploading(false);
            event.target.value = '';
        }
    };

    return (
        <div className="profile-pic">
            <div className="profile-pic-frame">
                {imageSrc ? (
                    <img alt="Profile" src={imageSrc} />
                ) : (
                    <div className="profile-pic-fallback" aria-hidden="true">
                        <i className="bi-person-fill" />
                    </div>
                )}
            </div>
            {isLoggedInUser && (
                <>
                    <input
                        ref={inputRef}
                        className="profile-pic-input"
                        type="file"
                        accept="image/png,image/jpeg,image/webp"
                        onChange={handleFileChange}
                    />
                    <button
                        className="btn profile-primary-button profile-pic-button"
                        type="button"
                        disabled={isUploading}
                        onClick={() => inputRef.current?.click()}
                    >
                        {isUploading ? 'Uploading...' : 'Upload photo'}
                    </button>
                    {uploadError && (
                        <p className="profile-inline-error">{uploadError}</p>
                    )}
                </>
            )}
        </div>
    );
};

export default ProfilePicture;
